export default __webpack_public_path__ + "static/media/home-travel-agency-destination-img01.93d3268a.jpg";